// import React from "react";
// import "./ServicesSection.css";
// import ab1 from "../Images/ab1.jpeg";
// import ab2 from "../Images/ab2.jpg";
// import ab3 from "../Images/ab3.jpg";
// import ab4 from "../Images/ab4.jpeg";
// import ithero from "../Images/it-hero.jpg";
// import slider9 from "../Images/slider-9.jpg"
// import slider10 from '../Images/slider-101.jpg';

// import { FaServer, FaVolumeUp, FaShieldAlt, FaNetworkWired, FaLeaf } from "react-icons/fa"; // example icons
// import { useNavigate } from "react-router-dom";


// const services = [
//   { title: "Acoustics", link: "/service/acoustics", img: ab3, icon: <FaNetworkWired /> , desc:'Infosight provides comprehensive Building Acoustics services that address environmental noise, internal ambient noise, airborne and impact sound insulation, room acoustic comfort, and mechanical system noise control.'},
//   { title: "Security", link: "/service/security", img: ab4, icon: <FaShieldAlt /> ,    desc:"Infosight Consultants provides comprehensive security design solutions focused on safeguarding assets, mitigating risks, and delivering fully integrated protection strategies tailored to each project."},
 
 
//    {
//     title: "IT / ICT",
//     link: "/service/it/ict",
//     img: ithero, // it-hero.jpg
//     icon: <FaNetworkWired />,
//     desc:
//       "A fully integrated ICT communication network is essential to modern ELV (Extra Low Voltage) systems, enabling seamless connectivity, efficient operations, and smart automation across building infrastructures.",
//   },


//    { title: "IBMS", link: "/service/ibms", img: ab2, icon: <FaServer /> ,  desc:"Infosight Consultants will develop preliminary Integrated Building Management System design deliverables strictly within the ELV design scope, focusing only on design inputs and documentation that inform accurate tendering and coordination."},
 
 
//   { title: "Audio / Visual (AV) Systems", link: "/service/av", img: ab1, icon: <FaVolumeUp />,  desc:"Infosight Consultants delivers comprehensive Audio Visual (AV) design services that enable seamless communication, collaboration, and media delivery across a wide range of environments." },
 
//   {
//     title: "Sustainability & Green Building",
//     link: "/service/sustainability-&-green-building",
//     img: slider9, // slider-9.jpg
//     icon: <FaLeaf />,
//     desc:
//       "By aligning with globally recognized standards such as LEED, BREEAM, Estidama, Mostadam, WELL, Al Sa’fat, IGBC, GRIHA etc., Infosight conducts a Sustainability Assessment and Green Building Rating Strategy in accordance with international best practices.",
//   },
// ];



// export default function ServicesSection() {
//   const navigate = useNavigate(); // Use the useNavigate hook

//   return (
//     <section id="services" className="services-section">
//       <div className="container">
//         {/* <h2 className="section-title" data-aos="fade-up">
//           Our Services
//         </h2>
//         <p className="section-subtitle" data-aos="fade-up" data-aos-delay={100}>
//          We assure you that our AV specialist designers hold Infocomm’s CTS certification along with other industry credentials and completed a HEALTHCARE IT, AV, ICT & SECURITY design of a large multi-specialty 500 Bed-Hospital Project in Tirupati, Andhra Pradesh, India.
//         </p> */}
//         <div className="services-grid">
//           {services.map((service, index) => (
//             <div
//               key={index}
//               className="service-card"
//               data-aos="zoom-in"
//               data-aos-delay={index * 150 + 200}
//               onClick={() => navigate(service.link)}
//               role="button"
//               tabIndex={0}
//               onKeyDown={(e) => {
//                 if (e.key === "Enter") navigate(service.link);
//               }}
//               aria-label={`Explore ${service.title} service`}
//             >
//               <div className="card-image">
//                 <img src={service.img} alt={service.title} />
//               </div>
//          <div className="card-overlay">
//   <div className="overlay-content">
//     <div className="service-icon">{service.icon}</div>
//       <p className="desc">{service.desc}</p>
//     <h3>{service.title}</h3>
//     <p>Explore more →</p>
//   </div>
// </div>

//             </div>
//           ))}
//         </div>
//       </div>
//     </section>
//   );
// }



import React from "react";
import { useNavigate } from "react-router-dom";
import {
  FaServer,
  FaVolumeUp,
  FaShieldAlt,
  FaNetworkWired,
  FaLeaf,
  FaArrowRight,
  FaCogs,
} from "react-icons/fa";

// Image Imports
import ab1 from "../Images/ab1.jpeg";
import ab2 from "../Images/ab2.jpg";
import ab3 from "../Images/ab3.jpg";
import ab4 from "../Images/ab4.jpeg";
import ithero from "../Images/it-hero.jpg";
import slider9 from "../Images/slider-9.jpg";

// Eye-Comfort High-End Real Estate & Architectural Palette
const theme = {
  bgSection: "#F8FAF9",
  bgCard: "#FFFFFF",
  bgSubtle: "#F1F5F9",
  primary: "#0F172A", // Deep Slate Navy
  accent: "#0D9488", // Soft Emerald Teal
  accentLight: "#CCFBF1",
  textDark: "#1E293B",
  textMuted: "#64748B",
  border: "#E2E8F0",
  shadowSm: "0 1px 3px rgba(0, 0, 0, 0.05)",
  shadowMd: "0 10px 25px -5px rgba(0, 0, 0, 0.05), 0 8px 10px -6px rgba(0, 0, 0, 0.01)",
  shadowLg: "0 20px 25px -5px rgba(0, 0, 0, 0.08), 0 10px 10px -5px rgba(0, 0, 0, 0.02)",
};

// Global Responsive Injection
const inlineStyles = `
  .services-rich-wrapper {
    background-color: ${theme.bgSection};
    padding: 80px 20px;
    font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
  }

  /* Grid Layout */
  .services-grid-container {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(340px, 1fr));
    gap: 32px;
    max-width: 1200px;
    margin: 40px auto 0;
  }

  /* Service Card */
  .service-card-item {
    background-color: ${theme.bgCard};
    border-radius: 18px;
    border: 1px solid ${theme.border};
    overflow: hidden;
    box-shadow: ${theme.shadowSm};
    transition: transform 0.35s ease, box-shadow 0.35s ease, border-color 0.35s ease;
    cursor: pointer;
    display: flex;
    flex-direction: column;
    outline: none;
  }

  .service-card-item:hover {
    transform: translateY(-8px);
    box-shadow: ${theme.shadowMd};
    border-color: ${theme.accent};
  }

  .service-image-container {
    position: relative;
    height: 220px;
    overflow: hidden;
  }

  .service-card-img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    transition: transform 0.5s ease;
  }

  .service-card-item:hover .service-card-img {
    transform: scale(1.06);
  }

  .service-icon-badge {
    position: absolute;
    bottom: 2px;
    right: 24px;
    width: 48px;
    height: 48px;
    border-radius: 12px;
    background-color: ${theme.primary};
    color: #FFFFFF;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 1.25rem;
    box-shadow: ${theme.shadowMd};
    border: 3px solid ${theme.bgCard};
    transition: background-color 0.3s ease, transform 0.3s ease;
  }

  .service-card-item:hover .service-icon-badge {
    background-color: ${theme.accent};
    transform: scale(1.1);
  }

  .service-card-body {
    padding: 32px 24px 24px;
    display: flex;
    flex-direction: column;
    flex: 1;
  }

  .service-desc-text {
    color: ${theme.textMuted};
    font-size: 0.925rem;
    line-height: 1.6;
    margin-bottom: 20px;
    display: -webkit-box;
    -webkit-line-clamp: 3;
    -webkit-box-orient: vertical;
    overflow: hidden;
  }

  .service-card-cta {
    margin-top: auto;
    padding-top: 16px;
    border-top: 1px solid ${theme.border};
    display: flex;
    align-items: center;
    justify-content: space-between;
    color: ${theme.accent};
    font-weight: 600;
    font-size: 0.9rem;
    transition: color 0.2s ease;
  }

  .service-card-item:hover .service-card-cta {
    color: ${theme.primary};
  }

  @media (max-width: 992px) {
    .services-grid-container {
      grid-template-columns: repeat(auto-fill, minmax(280px, 1fr));
      gap: 24px;
    }
  }

  @media (max-width: 600px) {
    .services-rich-wrapper {
      padding: 50px 16px;
    }
    .services-grid-container {
      grid-template-columns: 1fr;
      gap: 20px;
    }
  }
`;

const services = [
  {
    title: "Acoustics",
    link: "/service/acoustics",
    img: ab3,
    icon: <FaNetworkWired />,
    desc: "Infosight provides comprehensive Building Acoustics services addressing environmental noise, room acoustic comfort, sound insulation, and mechanical noise control.",
  },
  {
    title: "Security & Risk",
    link: "/service/security",
    img: ab4,
    icon: <FaShieldAlt />,
    desc: "Comprehensive security design solutions focused on safeguarding assets, mitigating risks, and delivering fully integrated protection strategies.",
  },
  {
    title: "IT / ICT Networks",
    link: "/service/it/ict",
    img: ithero,
    icon: <FaNetworkWired />,
    desc: "Integrated ICT communication networks enabling connectivity, smart automation, and efficient ELV systems across modern building infrastructures.",
  },
  {
    title: "IBMS Solutions",
    link: "/service/ibms",
    img: ab2,
    icon: <FaServer />,
    desc: "Integrated Building Management System design deliverables informing accurate tendering and seamless ELV scope coordination.",
  },
  {
    title: "Audio / Visual (AV) Systems",
    link: "/service/av",
    img: ab1,
    icon: <FaVolumeUp />,
    desc: "Delivering Audio Visual design services that enable seamless collaboration, media delivery, and immersive communication across environments.",
  },
  {
    title: "Sustainability & Green Building",
    link: "/service/sustainability-&-green-building",
    img: slider9,
    icon: <FaLeaf />,
    desc: "Conducting sustainability assessment strategies aligned with international standards like LEED, BREEAM, Estidama, Mostadam, and WELL.",
  },
];

export default function ServicesSection() {
  const navigate = useNavigate();

  return (
    <section id="services" className="services-rich-wrapper">
      <style>{inlineStyles}</style>

      <div style={{ maxWidth: "1200px", margin: "0 auto" }}>
        {/* Section Heading Header */}
        <div style={{ textAlign: "center", maxWidth: "800px", margin: "0 auto" }}>
          <span
            style={{
              color: theme.accent,
              fontWeight: "600",
              fontSize: "0.85rem",
              letterSpacing: "1.2px",
              textTransform: "uppercase",
              backgroundColor: theme.accentLight,
              padding: "6px 16px",
              borderRadius: "20px",
              display: "inline-block",
              marginBottom: "12px",
            }}
          >
            Engineering Expertise
          </span>

          <h2
            style={{
              fontSize: "2.25rem",
              fontWeight: "800",
              color: theme.primary,
              marginBottom: "12px",
              lineHeight: "1.25",
            }}
          >
            Specialized Consulting Services
          </h2>

          <p style={{ color: theme.textMuted, fontSize: "1rem", lineHeight: "1.6" }}>
            Precision-engineered, scalable, and intelligent design solutions tailored for iconic healthcare, corporate, and mixed-use real estate developments.
          </p>
        </div>

        {/* Services Grid */}
        <div className="services-grid-container">
          {services.map((service, index) => (
            <div
              key={index}
              className="service-card-item"
              onClick={() => navigate(service.link)}
              role="button"
              tabIndex={0}
              onKeyDown={(e) => {
                if (e.key === "Enter") navigate(service.link);
              }}
              aria-label={`Explore ${service.title} service`}
            >
              {/* Card Image Banner & Badge */}
              <div className="service-image-container">
                <img src={service.img} alt={service.title} className="service-card-img" />
                <div className="service-icon-badge">{service.icon}</div>
              </div>

              {/* Card Content Body */}
              <div className="service-card-body">
                <h3
                  style={{
                    fontSize: "1.25rem",
                    fontWeight: "700",
                    color: theme.primary,
                    marginBottom: "10px",
                  }}
                >
                  {service.title}
                </h3>

                <p className="service-desc-text">{service.desc}</p>

                {/* Interactive CTA Link */}
                <div className="service-card-cta">
                  <span>Explore Service</span>
                  <FaArrowRight size={14} />
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}